import ModalViewModel from 'infra/ModalViewModel'
import { required, validationContext } from 'validx'
import { action, observable, makeObservable } from 'mobx'
import { task } from 'mobx-task'
import Job from '../../../../Job'
import JobStore from '../../../../JobStore'
import { AlertFactory, AlertState } from '../../../../../alerts/Alert'
import { DateZero } from '../../../../../utils/date-util'

export class UpdateDeadlineDialogViewModel extends ModalViewModel {
  constructor(
    public job: Job,
    private jobStore: JobStore,
    private alertFactory: AlertFactory,
  ) {
    super()

    makeObservable(this)

    this.close$.subscribe(this.reset)
  }

  @observable
  deadline = this.job.dateDeadline ?? DateZero()

  validation = validationContext(this, {
    deadline: [required('A deadline is required')],
  })

  @action.bound
  validate() {
    return this.validation.reset().validate().isValid
  }

  update = task.resolved(async () => {
    if (!this.validate()) {
      return
    }

    const alert = this.alertFactory()
      .withState(AlertState.Pending)
      .saying('Updating Deadline', 'Hang tight!')
      .show()

    try {
      await this.jobStore.updateDeadline(this.job.id, this.deadline)

      alert
        .withState(AlertState.Success)
        .saying('Success!', 'Deadline has been updated!')

      this.close()
    } catch (e) {
      console.error(e)

      alert.withState(AlertState.Error).fromError(e).autoDismiss()
    }
  })

  @action.bound
  reset() {
    this.deadline = this.job.dateDeadline ?? DateZero()
  }
}
